import imrequest from '@/utils/imrequest.js'

// 用户登录获取imtoken
export function userLogin(data) {
  return imrequest({
    url: '/api/v1/user/login',
    method: 'post',
    data
  })
}


// 频道消息列表
export function messageChannelSync(data) {
  return imrequest({
    url: '/api/v1/message/channel/sync',
    method: 'post',
    data
  })
}

// 频道信息
export function channelsData(channel) {
  return imrequest({
    url: `/api/v1/channels/${channel.channelID}/${channel.channelType}`,
    method: 'get',
  })
}

export function isJoinGroup(channelID,username) {
  return imrequest({
    url: `/api/v1/groups/${channelID}/check-member-by-username?username=${username}`,
    method: 'get',
  })
}

// 最近会话列表
export function conversationSync(data) {
  return imrequest({
    url: '/api/v1/conversation/sync',
    method: 'post',
    data
  })
}
// 设置最近会话未读数
export function coversationClearUnread(data) {
  return imrequest({
    url: '/api/v1/coversation/clearUnread',
    method: 'put',
    data
  })
}
// 订阅者列表
export function membersync(data) {
  return imrequest({
    url: `/api/v1/groups/${data.channel.channelID}/membersync?version=${data.version}&limit=10000`,
    method: 'get',
  })
}
// 退出频道
export function exitChannel(channel) {
  return imrequest({
    url: `/api/v1/groups/${channel.channelID}/exit`,
    method: 'post',
  })
}
// 删除会话
export function deleteConversation(channel) {
  return imrequest({
    url: `/api/v1/conversations/${channel.channelID}/${channel.channelType}`,
    method: 'delete',
  })
}
// 修改频道属性
export function updateField(channel, data) {
  return imrequest({
    url: `/api/v1/groups/${channel.channelID}`,
    method: 'put',
    data
  })
}

// 群频道修改设置
export function updateSettingGroups(channel, data) {
  return imrequest({
    url: `/api/v1/groups/${channel.channelID}/setting`,
    method: 'put',
    data
  })
}
// 个人频道修改设置
export function updateSettingUsers(channel, data) {
  return imrequest({
    url: `/api/v1/users/${channel.channelID}/setting`,
    method: 'put',
    data
  })
}

// 清空聊天记录
export function messageOffset(data) {
  return imrequest({
    url: `/api/v1/message/offset`,
    method: 'post',
    data
  })
}

// 撤回消息
export function messageRevoke(data) {
  return imrequest({
    url: `/api/v1/message/revoke?channel_id=${data.channel_id}&channel_type=${data.channel_type}&message_id=${data.message_id}&client_msg_no=${data.client_msg_no}`,
    method: 'post',
  })
}

// 上传群头像
export function uploadGroupsAvatar(channel,data) {
  return imrequest({
    url: `/api/v1/groups/${channel.channelID}/avatar`,
    method: 'post',
    data:data,
    headers: { "Content-Type": "multipart/form-data"}
  })
}

// 创建群
export function groupCreate(data) {
  return imrequest({
    url: `/api/v1/group/create`,
    method: 'post',
    data
  })
}

// 加群
export function groupsMembers(channelID,data) {
  return imrequest({
    url: `/api/v1/groups/${channelID}/members`,
    method: 'post',
    data
  })
}

// 修改群个人信息
export function subscriberAttrUpdate(channel,subscriberUID, data) {
  return imrequest({
    url: `/api/v1/groups/${channel.channelID}/members/${subscriberUID}`,
    method: 'put',
    data
  })
}